import { ResponseError } from '../../errors/responseError';
import { fetchGetTips, TGetTipsResponse } from '../../repositories/text-search/v3/get-tips';
import { IApplicationContext } from '../../types/applicationContext';
import { ITips } from '../../types/tips';

const DEGRADATION_TELEMETRY_KEY = 'degradation.getMainTips';

export async function fetchMainTips(context: IApplicationContext, text: string): Promise<ITips | null> {
  const { httpApi, logger, telemetry } = context;

  try {
    const { statusCode, response }: TGetTipsResponse = await fetchGetTips({
      httpApi,
      parameters: {
        text,
      },
    });
    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);

      const responseError = new ResponseError({
        domain: 'services.fetchMainTips',
        message: response.message || '',
        details: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: response.errors as any,
        },
      });

      logger.warning(responseError);
      throw responseError;
    }

    return response;
  } catch (ex) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(ex);

    return null;
  }
}
